import { FC, useState } from "react"
import styles from "./datePeriodPicker.module.scss"
import { DatePicker } from "../../components/datePicker/datePicker";
import { DateTime } from "luxon";

export interface IDatePeriod {
    startDate: DateTime | null,
    endDate: DateTime | null
}

interface IDatePeriodPickerProps{
    period?: IDatePeriod,
    onPeriodChange?: (value: IDatePeriod) => void
    disabled?: boolean
    calendarHeight?: number
}

export const MinDateText = '1900-01-01'
export const MaxDateText = '2999-12-31'

export const MinDate = DateTime.fromJSDate(new Date(MinDateText));
export const MaxDate = DateTime.fromJSDate(new Date(MaxDateText));

const DatePeriodPicker:FC<IDatePeriodPickerProps> = (props) => {

    const [incorrectPeriod, setIncorrectPeriod] = useState<boolean>(false);

    return (
        <div className={styles.datePeriodPicker}>
            <DatePicker 
                date={props.period?.startDate} 
                onBlur={value => {
                    if ((value as DateTime) > (props.period?.endDate as DateTime)) {
                        setIncorrectPeriod(true);
                        props.onPeriodChange?.({startDate: value?.day ? value : MinDate, endDate: value} as IDatePeriod);
                    } else {
                        setIncorrectPeriod(false);
                        props.onPeriodChange?.({startDate: value?.day ? value : MinDate, endDate: props.period?.endDate} as IDatePeriod);
                    }
                }}
                incorrectPeriod={incorrectPeriod}
                disabled={props.disabled}
                minDate={MinDateText}
                maxDate={MaxDateText}
                inputStyle={{height: props.calendarHeight}}
                clearButtonStyle={{height: props.calendarHeight}}
            />
            <div className={styles.separator}>一</div>
            <DatePicker 
                date={props.period?.endDate} 
                onBlur={value => {
                    if ((value as DateTime) < (props.period?.startDate as DateTime)) {
                        setIncorrectPeriod(true);
                        props.onPeriodChange?.({startDate: value, endDate: value?.day ? value : MaxDate} as IDatePeriod)
                    } else {
                        setIncorrectPeriod(false);
                        props.onPeriodChange?.({startDate: props.period?.startDate, endDate: value?.day ? value : MaxDate} as IDatePeriod)
                    }
                }}
                incorrectPeriod={incorrectPeriod}
                disabled={props.disabled}
                minDate={MinDateText}
                maxDate={MaxDateText}
                inputStyle={{height: props.calendarHeight}}
                clearButtonStyle={{height: props.calendarHeight}}
            />
        </div>
    )
}
export default DatePeriodPicker